import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import DataGrid, { Column, MasterDetail, Scrolling } from 'devextreme-react/cjs/data-grid'
import notistack from 'pages/Core/Notistack'
import { viewItemDetailsProp } from '../type'
import { getAssignProductList } from '../services/po.stock.service'

const ViewAssignedProducts: React.FC<viewItemDetailsProp> = ({ isOpen, onClose, selectedId }) => {
    const [data, setData] = useState<any>([])

    const getItemDetailsById = async (id: string) => {
        try {
            const response = await getAssignProductList({ id });
            if (Array.isArray(response.data)) {
                setData(response.data);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.error(error || 'Failed to fetch item details.');
        }
    }

    useEffect(() => {
        if (isOpen && selectedId) {
            getItemDetailsById(selectedId);
        }
    }, [isOpen, selectedId]);

    return (
        <>
            <Modal
                show={isOpen}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog-centered"
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Product Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
                    <DataGrid
                        dataSource={data}
                        showRowLines={true}
                        keyExpr="id"
                        showBorders={true}
                        columnAutoWidth={true}
                    >
                        <Scrolling
                            mode="standard"
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />

                        <Column dataField="materialType" caption="Material Type" width={130} />
                        <Column dataField="category" caption="Category" />
                        <Column dataField="color" caption="Color" />
                        <Column dataField="karat" caption="Karat" />
                        <Column dataField="styleNo" caption="Style No" />

                        <Column
                            dataField="actualGoldWeight"
                            caption="Gold Wt"
                            dataType="number"
                            format="#0.000"
                        />

                        <Column
                            dataField="actualDiamondWeight"
                            caption="Diamond Wt"
                            dataType="number"
                            format="#0.000"
                        />

                        <Column
                            dataField="goldCost"
                            caption="Gold Cost"
                            dataType="number"
                            format="#0.00"
                        />

                        <Column
                            dataField="diamondCost"
                            caption="Diamond Cost"
                            dataType="number"
                            format="#0.00"
                        />

                        <Column
                            dataField="makingCharges"
                            caption="Making Charges"
                            dataType="number"
                            format="#0.00"
                        />
                        <Column
                            dataField="totalCost"
                            caption="Selling Price"
                            dataType="number"
                            format="#0.00"
                        />
                    </DataGrid>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewAssignedProducts
